import React from 'react';


export const PayNowButton = ({onClick, shouldRenderPayNow}) => {
    return shouldRenderPayNow && <div className='invoice_pay'>
        <div>
            <button className='btn btn-primary btn-lg' type='button' id='pay_now'
                    onClick={onClick}>Pay now
            </button>
        </div>
    </div>
}
